import { Component } from 'react';

export class ContactComponent extends Component {
  componentWillUnmount() {
    this.props.setSharedState('serviceangebot', undefined);
  }
}
